import styled from 'styled-components';
import { Typography } from '../../global/theme';
import { AlignCenter } from '../../global/commonStyle';

interface Props {
  isPadding?: boolean;
}
const Wrapper = styled.div<Props>`
  gap: var(--space-4);
  ${AlignCenter}
  cursor: pointer;
  width: max-content;
  padding: ${(props) =>
    props.isPadding
      ? 'var(--space-3) var(--space-10) var(--space-3) var(--space-6)'
      : 'var(--space-5) var(--space-8) var(--space-5) var(--space-5)'};
  border-radius: var(--border-radius-8);
  transition: background var(--transition-fast);
  &:hover {
    background-color: var(--background-hover-navbar);
    p {
      color: var(--text-primary);
    }
    svg {
      fill: var(--text-primary);
    }
  }
  svg {
    fill: var(--text-secondary);
  }
  .icon-image {
    ${AlignCenter}
    border-radius: var(--border-radius-full);
    /* width: 20px;
    height: 20px; */
    object-fit: cover;
    overflow: hidden;
  }
`;

const Text = styled.p`
  ${Typography.body_md_medium};
  color: var(--text-secondary);
  margin: var(--space-0);
  text-align: center;
  p {
    ${Typography.body_sm};
    color: var(--text-primary);
  }
`;

export { Wrapper, Text };
